import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const SplashScreen = () => {
  const words = ['Hello', 'Hola', '你好', 'नमस्ते', 'مرحبا', 'হ্যালো', 'Olá', 'Hallo', 'こんにちは', 'Bonjour'];
  const [currentWordIndex, setCurrentWordIndex] = useState(0);
  const [isLoaded, setIsLoaded] = useState(false);

  // Rotate words every .25 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentWordIndex((prev) => (prev + 1) % words.length);
    }, 250);
    return () => clearInterval(interval);
  }, [words.length]);

  // Detect page load and enforce minimum display time
  useEffect(() => {
    const handleLoad = () => {
      setTimeout(() => {
        setIsLoaded(true);
      }, 2500); // Minimum 3s display
    };

    // Check if document is already loaded
    if (document.readyState === 'complete') {
      handleLoad();
    } else {
      window.addEventListener('load', handleLoad);
      return () => window.removeEventListener('load', handleLoad);
    }
  }, []);

  return (
    <AnimatePresence>
      {!isLoaded && (
        <motion.div
          className="fixed inset-0 flex flex-col items-center justify-center h-screen bg-customGrey z-50"
          initial={{ y: 0, opacity: 1 }}
          exit={{ y: '-100vh', opacity: 1 }}
          transition={{ duration: 0.8, ease: 'easeInOut' }}
        >
          <AnimatePresence mode="wait">
            <motion.h1
              key={currentWordIndex}
              className="text-white text-3xl sm:text-4xl md:text-7xl font-extralight"
              initial={{ opacity: 1, y: 20 }}
              transition={{ duration: 0.5 }}
            >
              {words[currentWordIndex]}
            </motion.h1>
          </AnimatePresence>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default SplashScreen;